import { COVERAGE_LABEL_FIELD } from "./types";

import type {
  GetContextMenuItemsParams,
  ICellRendererParams,
} from "ag-grid-community";
import type { CellReviewCellIdentity } from "../shared/cellReviews/useCellReviewContextMenu";
import type { CompsGridContext, CompsGridRow } from "./types";

const deriveCell = (
  field: string | undefined,
  rowGroupId: string | undefined,
  rowType: string | undefined,
): CellReviewCellIdentity | null => {
  // The feature applies to every column except Coverage, and to every row —
  // coverage (type/amount), subsidy, and notes rows all carry a rowGroupId
  // that uniquely identifies the row. The cell identity is the column itself
  // (carrierId / "requested" / "incumbent") plus that row.
  if (!field || field === COVERAGE_LABEL_FIELD || !rowGroupId || !rowType) {
    return null;
  }

  return { planId: field, fieldPath: `${rowGroupId}:${rowType}` };
};

/** Resolves the cell-review identity for CompsCellRenderer. */
export const deriveCompsCellForRenderer = (
  params: ICellRendererParams<CompsGridRow, unknown, CompsGridContext>,
): CellReviewCellIdentity | null =>
  deriveCell(
    params.colDef?.field,
    params.data?.rowGroupId,
    params.data?.rowType,
  );

/** Resolves the cell-review identity for the AG Grid context menu. */
export const deriveCompsCellForContextMenu = (
  params: GetContextMenuItemsParams<CompsGridRow, CompsGridContext>,
): CellReviewCellIdentity | null =>
  deriveCell(
    params.column?.getColDef()?.field,
    params.node?.data?.rowGroupId,
    params.node?.data?.rowType,
  );
